<template>
  <div>
    <img class="bg" src="https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/ad-meeting-bg.jpg" />

    <van-overlay :show="showOverlay" @click="showOverlay = false" z-index="99">
      <div class="overlay-wrapper">
        <div>
          点击页面右上角分享<img
            class="arrow"
            src="../../../assets/images/extra-style/arrow.png"
          />
        </div>
      </div>
    </van-overlay>
  </div>

</template>
<script>
import { commonUtils } from '@/utils/common'
export default {
  data () {
    return {
      showOverlay: false
    }
  },
  mounted () {
    this.initWxJsSdk()
  },
  methods: {
    // 初始化微信jssdk
    initWxJsSdk () {
    // console.log(window.__wxjs_is_wkwebview)
    // ios系统下，进行wx jssdk验证的url 应为第一次进入页面时的url
      let sdkUrl = null
      const u = navigator.userAgent
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIOS) {
        sdkUrl = global.entryUrl
      }
      const url = `${document.location.origin}/v2/activity/2021/activity-ad-meeting`
      const appMessageShare = {
        title: '汽修人们，快来博世易加拿好礼吧！', // 分享标题
        // desc: '线下活动desc', // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/ad-meeting-share-img.jpg', // 分享图标
        type: 'link', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
        // 用户点击了分享后执行的回调函数
          console.log('appMessageShare success' + url)
        },
        fail: function () {
          console.log('appMessageShare fail')
        }
      }

      const timelineShare = {
        title: '汽修人们，快来博世易加拿好礼吧！', // 分享标题
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/ad-meeting-share-img.jpg', // 分享图标
        success: function () {
        // 用户点击了分享后执行的回调函数
          console.log('timelineShare success' + url)
        },
        fail: function () {
          console.log('appMessageShare fail' + url)
        }
      }
      commonUtils.configWxJsSdk(appMessageShare, timelineShare, sdkUrl).then(() => {
        this.wxReady = true
      }).catch(error => {
        this.$emit('error', { errorMsg: error })
      })
    }
  }
}
</script>

<style lang='less' scoped>
.bg{
  width: 100%;
  display: block;
}
.overlay-wrapper {
  height: 100%;
  line-height: 120px;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  .arrow {
    padding-left: 10px;
    width: 80px;
  }
}
</style>
